/* =========================================================
   Affiche GOLF « Le trou » — un coup, un trou, une balle.
   API : SNGolfTrou.render(data, opts) -> string SVG
     data : { mode, parcours, lieu, date, joueur, titre, kicker,
              trou, par, distance, club, departs, temoins,
              putt, pente, resultat, numero, initiales,
              s1..s3 (3 stats libres « valeur|libellé ») }
       mode : 'trouenun' → trajectoire du tee au drapeau
              'green'    → courbes de niveau du green + ligne de putt
              'signature'→ plan du trou vu du ciel (dogleg, bunkers, eau)
              'balle'    → la balle en gros plan, numéro et marquage
     opts : { palette }
   Auto-suffisant → re-render serveur direct pour l'impression.
   ========================================================= */
(function () {
  const PW = 800, PH = 1066, MX = 64;

  const PALETTES = {
    green: { label:'Gazon', bg:'#0E3B2E', ink:'#F4F1E8', muted:'#8FB3A5', accent:'#FF6B2C', line:'#1C5544', card:'#134536', deep:'#0A2E23', sand:'#E4C68A', water:'#2E6E8E' },
    craie: { label:'Craie', bg:'#F7F4ED', ink:'#0B2D5B', muted:'#8B94A3', accent:'#FF6B2C', line:'#E3DDD0', card:'#FFFFFF', deep:'#DFE7DF', sand:'#E4C68A', water:'#7FB3CC' },
    nuit:  { label:'Nuit',  bg:'#0B2D5B', ink:'#F7F4ED', muted:'#93A1B8', accent:'#FF9E5C', line:'#1E4272', card:'#12355F', deep:'#082444', sand:'#D8B87C', water:'#2E6E8E' },
    sable: { label:'Sable', bg:'#EDE3D2', ink:'#2C3A2E', muted:'#8A8676', accent:'#C4622D', line:'#DDD0B9', card:'#F7F1E6', deep:'#DCCFB6', sand:'#D9BE8B', water:'#7FA9BC' },
  };

  const esc = s => String(s == null ? '' : s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
  const up = s => String(s == null ? '' : s).toUpperCase();
  const fit = (t, maxW, maxS, cwf, ls, minS) => { const n = String(t).length || 1; minS = minS || 12;
    for (let s = maxS; s > minS; s -= 1) if (n * (cwf * s + ls) <= maxW) return s; return minS; };
  const T = (x,y,size,fill,txt,o) => { o = o || {};
    return `<text x="${x}" y="${y}" font-family="${o.f||'Sora'}" font-size="${size}" font-weight="${o.w||600}" fill="${fill}"`
      + (o.ls?` letter-spacing="${o.ls}"`:'') + ` text-anchor="${o.a||'middle'}"` + (o.op?` opacity="${o.op}"`:'') + `>${txt}</text>`; };

  function flag(cx, baseY, h, p, col) {
    const top = baseY - h;
    return `<ellipse cx="${cx}" cy="${baseY}" rx="${h*0.16}" ry="${h*0.05}" fill="${p.deep}" opacity="0.55"/>`
      + `<circle cx="${cx}" cy="${baseY}" r="${h*0.075}" fill="${p.deep}"/>`
      + `<rect x="${cx-h*0.012}" y="${top}" width="${h*0.024}" height="${h}" rx="${h*0.012}" fill="${p.ink}"/>`
      + `<path d="M${cx+h*0.012} ${top+h*0.02} L${cx+h*0.30} ${top+h*0.105} L${cx+h*0.012} ${top+h*0.19} Z" fill="${col||p.accent}"/>`;
  }
  function ball(cx, cy, r, p, fill) {
    let d = '';
    for (let ring = 1; ring <= 3; ring++) {
      const rr = r * (0.30 + ring * 0.21), n = 6 + ring * 3;
      for (let i = 0; i < n; i++) {
        const a = (i / n) * Math.PI * 2 + ring * 0.4;
        const x = cx + Math.cos(a) * rr, y = cy + Math.sin(a) * rr;
        if (Math.sqrt((x-cx)*(x-cx) + (y-cy)*(y-cy)) > r - r*0.13) continue;
        d += `<circle cx="${x.toFixed(1)}" cy="${y.toFixed(1)}" r="${(r*0.062).toFixed(1)}" fill="${p.muted}" opacity="0.38"/>`;
      }
    }
    return `<circle cx="${cx}" cy="${cy}" r="${r}" fill="${fill||p.ink}"/>${d}`
      + `<circle cx="${cx-r*0.32}" cy="${cy-r*0.34}" r="${r*0.17}" fill="${p.card}" opacity="0.30"/>`;
  }
  function tee(cx, y, s, p) {
    return `<path d="M${cx-s*0.5} ${y} L${cx+s*0.5} ${y} L${cx+s*0.16} ${y+s*0.42} L${cx+s*0.10} ${y+s*1.25} L${cx-s*0.10} ${y+s*1.25} L${cx-s*0.16} ${y+s*0.42} Z" fill="${p.ink}"/>`;
  }
  /* Bandeau de stats : n'affiche que les cases renseignées. */
  function stats(p, items, y, x0) {
    x0 = x0 || 54;
    const it = items.filter(x => String(x[0] || '').trim());
    if (!it.length) return '';
    const w = (PW - 2*x0) / it.length;
    let s = `<line x1="${x0}" y1="${y-34}" x2="${PW-x0}" y2="${y-34}" stroke="${p.line}" stroke-width="1.5"/>`;
    it.forEach((c, i) => {
      const cc = x0 + w*i + w/2;
      if (i) s += `<line x1="${(x0+w*i).toFixed(0)}" y1="${y-14}" x2="${(x0+w*i).toFixed(0)}" y2="${y+34}" stroke="${p.line}" stroke-width="1.5"/>`;
      const vs = fit(c[0], w - 24, 38, 0.56, 0, 18);
      s += T(cc, y+6, vs, p.ink, esc(c[0]), { f:'Oswald', w:700 }) + T(cc, y+30, 12, p.muted, esc(up(c[1])), { w:600, ls:2.5 });
    });
    return s;
  }

  function render(data, opts) {
    data = data || {}; opts = opts || {};
    const p = PALETTES[opts.palette] || PALETTES.green;
    const mode = String(data.mode || 'trouenun').toLowerCase();
    const cx = PW / 2;

    const DEF = { trouenun:'TROU EN UN', green:'LE PUTT', signature:'LE TROU', balle:'MA BALLE' };
    const titre = up(data.titre) || up(data.parcours) || DEF[mode] || 'MON TROU';
    const ts = fit(titre, 700, 74, 0.54, 2, 34);
    const kicker = up(data.kicker) || DEF[mode];
    const sousParts = [up(data.lieu)];
    if (data.trou) sousParts.push('TROU N° ' + up(data.trou));
    if (data.par) sousParts.push('PAR ' + up(data.par));
    const sous = sousParts.filter(Boolean).join(' · ');

    const libres = [[data.s1, data.l1], [data.s2, data.l2], [data.s3, data.l3]];
    let corps = '', barreY = 946;

    if (mode === 'trouenun') {
      corps = `<ellipse cx="600" cy="806" rx="158" ry="58" fill="${p.card}"/>`
        + `<ellipse cx="600" cy="806" rx="158" ry="58" fill="none" stroke="${p.line}" stroke-width="2"/>`
        + `<path d="M120 880 C 240 470, 500 430, 600 748" fill="none" stroke="${p.accent}" stroke-width="3" stroke-dasharray="9 8" stroke-linecap="round" opacity="0.9"/>`
        + flag(600, 796, 206, p) + tee(120, 880, 26, p) + ball(120, 862, 15, p, p.ink)
        + T(cx, 456, 150, p.ink, esc(up(data.distance) || '—'), { f:'Oswald', w:700 })
        + T(cx, 492, 16, p.muted, 'DISTANCE', { w:700, ls:9 });
    } else if (mode === 'green') {
      corps = `<ellipse cx="400" cy="640" rx="300" ry="222" fill="${p.card}"/>`
        + `<ellipse cx="400" cy="640" rx="300" ry="222" fill="none" stroke="${p.line}" stroke-width="2"/>`
        + `<ellipse cx="400" cy="640" rx="228" ry="168" fill="none" stroke="${p.line}" stroke-width="1.4" opacity="0.55"/>`
        + `<ellipse cx="400" cy="640" rx="150" ry="110" fill="none" stroke="${p.line}" stroke-width="1.4" opacity="0.4"/>`
        + `<path d="M258 758 C 300 678, 356 658, 424 614" fill="none" stroke="${p.accent}" stroke-width="3.5" stroke-dasharray="10 9" stroke-linecap="round"/>`
        + flag(430, 606, 150, p) + ball(258, 758, 15, p, p.ink)
        + T(258, 802, 12, p.muted, 'MA BALLE', { w:700, ls:2.5 })
        + `<text x="${cx}" y="352" text-anchor="middle" font-family="Oswald" font-weight="700" fill="${p.ink}"><tspan font-size="112">${esc(up(data.putt) || '—')}</tspan></text>`
        + T(cx, 390, 15, p.muted, 'LONGUEUR DU PUTT', { w:600, ls:5 });
    } else if (mode === 'signature') {
      const fw = 'M348 918 C 300 786, 300 706, 372 632 C 452 550, 520 530, 560 462 C 596 408, 570 372, 512 348';
      corps = `<path d="${fw}" fill="none" stroke="${p.card}" stroke-width="118" stroke-linecap="round" stroke-linejoin="round"/>`
        + `<path d="${fw}" fill="none" stroke="${p.line}" stroke-width="112" stroke-linecap="round" stroke-linejoin="round" opacity="0.55"/>`
        + `<ellipse cx="286" cy="768" rx="46" ry="26" fill="${p.sand}" transform="rotate(-24 286 768)"/>`
        + `<ellipse cx="616" cy="552" rx="38" ry="22" fill="${p.sand}" transform="rotate(30 616 552)"/>`
        + `<path d="M436 664 q 46 -30 92 -6 q -12 44 -56 46 q -40 0 -36 -40 Z" fill="${p.water}" opacity="0.85"/>`
        + `<ellipse cx="512" cy="348" rx="92" ry="58" fill="${p.card}"/>`
        + `<ellipse cx="512" cy="348" rx="92" ry="58" fill="none" stroke="${p.accent}" stroke-width="2" opacity="0.5"/>`
        + flag(512, 342, 100, p)
        + `<rect x="330" y="910" width="36" height="9" rx="4.5" fill="${p.ink}"/>`
        + T(348, 950, 12, p.muted, 'DÉPART', { w:700, ls:3 });
      barreY = 1016;
    } else { /* balle */
      corps = ball(cx, 560, 230, p, p.ink)
        + T(cx, 540, 150, p.bg, esc(up(data.numero) || '1'), { f:'Oswald', w:700 })
        + `<line x1="${cx-60}" y1="580" x2="${cx+60}" y2="580" stroke="${p.accent}" stroke-width="5"/>`
        + T(cx, 632, 26, p.bg, esc(up(data.initiales) || ''), { f:'Oswald', w:700, ls:4 });
      barreY = 900;
    }

    const defauts = mode === 'trouenun' ? [[data.club,'Club'],[data.departs,'Départs'],[data.temoins,'Témoins']]
      : mode === 'green' ? [[data.resultat,'Résultat'],[data.pente,'Pente'],[data.club,'Club']]
      : mode === 'signature' ? [[data.distance,'Longueur'],[data.par ? 'Par ' + data.par : '','Normale'],[data.resultat,'Mon record']]
      : [[data.distance,'Distance'],[data.club,'Club'],[data.trou ? 'Trou ' + data.trou : '','Repère']];
    const cases = libres.some(l => String(l[0] || '').trim()) ? libres.map(l => [l[0], l[1] || '']) : defauts;

    return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${PW} ${PH}" font-family="'Sora','Inter',sans-serif">
<rect width="${PW}" height="${PH}" fill="${p.bg}"/>
${T(cx, 84, 19, p.accent, esc(kicker), { w:700, ls:5 })}
${T(cx, 168, ts, p.ink, esc(titre), { f:'Oswald', w:700, ls:2 })}
${sous ? T(cx, 204, 17, p.muted, esc(sous), { w:600, ls:3.5 }) : ''}
${corps}
${stats(p, cases, barreY)}
${data.joueur ? T(cx, mode === 'balle' ? 1000 : 1030, 19, p.ink, esc(up(data.joueur)), { f:'Oswald', w:700, ls:2 }) : ''}
${data.date && mode === 'balle' ? T(cx, 1030, 14, p.muted, esc(up(data.date)), { w:600, ls:4 }) : ''}
</svg>`;
  }

  window.SNGolfTrou = { render, PALETTES };
})();
